import type { Actor } from '@/types/content';

export const actors: Actor[] = [
  {
    id: 1,
    name: '林知远',
    role: '饰 陈默',
    avatar:
      'https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20handsome%20young%20Chinese%20male%20actor%20in%20his%20late%20twenties%2C%20calm%20confident%20expression%2C%20soft%20neutral%20grey%20studio%20background%2C%20cinematic%20editorial%20lighting%2C%20sharp%20detail%2C%20vertical%20magazine%20cover%20style%2C%20harmonious%20warm%20neutral%20tones&width=520&height=680&seq=drama-actor01-portrait-2024&orientation=portrait',
    birth: '1994年5月',
    birthPlace: '浙江杭州',
    height: '183cm',
    bio: '林知远毕业于中央戏剧学院表演系，以细腻克制的表演风格见长。他擅长塑造内心戏丰富的都市青年形象，在《女友的妈妈》中饰演男主角陈默，把一个努力在感情与家庭压力之间寻找平衡的年轻人刻画得真实可信。',
    episodeIds: [1, 2, 3, 5, 6, 7, 8, 10, 11, 12],
  },
  {
    id: 2,
    name: '苏晚晴',
    role: '饰 赵慧兰',
    avatar:
      'https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20an%20elegant%20Chinese%20mature%20female%20actress%20in%20her%20early%20fifties%2C%20dignified%20restrained%20expression%2C%20soft%20neutral%20grey%20studio%20background%2C%20cinematic%20editorial%20lighting%2C%20sharp%20detail%2C%20vertical%20magazine%20cover%20style%2C%20harmonious%20warm%20neutral%20tones&width=520&height=680&seq=drama-actor02-portrait-2024&orientation=portrait',
    birth: '1972年11月',
    birthPlace: '北京',
    height: '168cm',
    bio: '苏晚晴是国家一级演员，从业三十余年，塑造过大量深入人心的母亲与女性角色。她以极强的情绪控制力著称，在《女友的妈妈》中饰演赵慧兰，用大量留白与停顿，演活了一位表面强硬、内心柔软的单身母亲。',
    episodeIds: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
  },
  {
    id: 3,
    name: '何思彤',
    role: '饰 林夏',
    avatar:
      'https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20bright%20young%20Chinese%20female%20actress%20in%20her%20mid%20twenties%2C%20gentle%20determined%20expression%2C%20soft%20neutral%20grey%20studio%20background%2C%20cinematic%20editorial%20lighting%2C%20sharp%20detail%2C%20vertical%20magazine%20cover%20style%2C%20harmonious%20warm%20neutral%20tones&width=520&height=680&seq=drama-actor03-portrait-2024&orientation=portrait',
    birth: '1997年3月',
    birthPlace: '江苏南京',
    height: '165cm',
    bio: '何思彤是近年来备受关注的新生代女演员，凭青春剧出道后不断拓宽戏路。在《女友的妈妈》中，她饰演女主角林夏，细腻呈现了一个夹在母亲与恋人之间的女孩，从任性到理解的成长弧线。',
    episodeIds: [1, 2, 3, 5, 6, 7, 8, 9, 10, 11, 12],
  },
  {
    id: 4,
    name: '郑鸿',
    role: '饰 陈父',
    avatar:
      'https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20seasoned%20Chinese%20male%20actor%20in%20his%20late%20fifties%2C%20stern%20thoughtful%20expression%2C%20soft%20neutral%20grey%20studio%20background%2C%20cinematic%20editorial%20lighting%2C%20sharp%20detail%2C%20vertical%20magazine%20cover%20style%2C%20harmonious%20cool%20neutral%20tones&width=520&height=680&seq=drama-actor04-portrait-2024&orientation=portrait',
    birth: '1965年8月',
    birthPlace: '山东青岛',
    height: '178cm',
    bio: '郑鸿是观众熟悉的老戏骨，擅长演绎传统而复杂的父亲形象。在《女友的妈妈》中，他饰演陈默的父亲，一位观念守旧却深爱儿子的长辈，与赵慧兰的交锋成为剧中家庭观念的集中体现。',
    episodeIds: [10, 11, 12],
  },
  {
    id: 5,
    name: '白露',
    role: '饰 赵慧兰（青年）',
    avatar:
      'https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20young%20Chinese%20female%20actress%20in%20her%20early%20twenties%20with%20nostalgic%20gentle%20expression%2C%20soft%20neutral%20grey%20studio%20background%2C%20cinematic%20editorial%20lighting%2C%20sharp%20detail%2C%20vertical%20magazine%20cover%20style%2C%20harmonious%20warm%20neutral%20tones&width=520&height=680&seq=drama-actor05-portrait-2024&orientation=portrait',
    birth: '2000年9月',
    birthPlace: '四川成都',
    height: '167cm',
    bio: '白露为科班出身的新人演员，气质清冷。她在《女友的妈妈》中饰演青年时期的赵慧兰，承担了剧中全部回忆线索，用克制的表演还原了母亲年轻时的另一段人生。',
    episodeIds: [4, 6, 9],
  },
  {
    id: 6,
    name: '高维',
    role: '饰 周明',
    avatar:
      'https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20Chinese%20male%20actor%20in%20his%20late%20forties%20with%20warm%20sincere%20expression%2C%20soft%20neutral%20grey%20studio%20background%2C%20cinematic%20editorial%20lighting%2C%20sharp%20detail%2C%20vertical%20magazine%20cover%20style%2C%20harmonious%20warm%20neutral%20tones&width=520&height=680&seq=drama-actor06-portrait-2024&orientation=portrait',
    birth: '1976年2月',
    birthPlace: '上海',
    height: '180cm',
    bio: '高维是话剧舞台出身的中年演员，台词功底扎实。在《女友的妈妈》中，他饰演赵慧兰的旧友周明，是揭开往事的关键人物，也是全剧最复杂的配角之一。',
    episodeIds: [10],
  },
  {
    id: 7,
    name: '温情',
    role: '饰 陈母',
    avatar:
      'https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20a%20friendly%20Chinese%20mature%20female%20actress%20in%20her%20early%20fifties%20with%20gentle%20warm%20expression%2C%20soft%20neutral%20grey%20studio%20background%2C%20cinematic%20editorial%20lighting%2C%20sharp%20detail%2C%20vertical%20magazine%20cover%20style%2C%20harmonious%20warm%20neutral%20tones&width=520&height=680&seq=drama-actor07-portrait-2024&orientation=portrait',
    birth: '1970年6月',
    birthPlace: '辽宁沈阳',
    height: '163cm',
    bio: '温情长期活跃在家庭剧领域，被称为「国民妈妈」之一。在《女友的妈妈》中，她饰演陈默的母亲，以温和的立场与赵慧兰形成对比，是促成两家人和解的重要力量。',
    episodeIds: [10, 12],
  },
  {
    id: 8,
    name: '顾城',
    role: '饰 老李',
    avatar:
      'https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20an%20older%20Chinese%20male%20supporting%20actor%20in%20his%20sixties%20with%20kind%20weathered%20expression%2C%20soft%20neutral%20grey%20studio%20background%2C%20cinematic%20editorial%20lighting%2C%20sharp%20detail%2C%20vertical%20magazine%20cover%20style%2C%20harmonious%20cool%20neutral%20tones&width=520&height=680&seq=drama-actor08-portrait-2024&orientation=portrait',
    birth: '1958年12月',
    birthPlace: '广东广州',
    height: '172cm',
    bio: '顾城是经验丰富的性格演员，善于用极少的戏份留下鲜明印象。在《女友的妈妈》中，他饰演林家的老邻居老李，是街坊间的「人间清醒」，几句直言常常点醒剧中人。',
    episodeIds: [2, 4, 12],
  },
];